/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/WorkshopParticipant', 'model/WorkshopParticipantRole', 'model/WorkshopPhaseReport', 'model/WorkshopVideoCall'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./WorkshopParticipant'), require('./WorkshopParticipantRole'), require('./WorkshopPhaseReport'), require('./WorkshopVideoCall'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.WorkshopReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.WorkshopParticipant, root.ForStractionServiceApi.WorkshopParticipantRole, root.ForStractionServiceApi.WorkshopPhaseReport, root.ForStractionServiceApi.WorkshopVideoCall);
  }
}(this, function(ApiClient, WorkshopParticipant, WorkshopParticipantRole, WorkshopPhaseReport, WorkshopVideoCall) {
  'use strict';




  /**
   * The WorkshopReport model module.
   * @module model/WorkshopReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>WorkshopReport</code>.
   * @alias module:model/WorkshopReport
   * @class
   */
  var exports = function() {
    var _this = this;
























  };

  /**
   * Constructs a <code>WorkshopReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/WorkshopReport} obj Optional instance to populate.
   * @return {module:model/WorkshopReport} The populated <code>WorkshopReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('AreResultsFilterable')) {
        obj['AreResultsFilterable'] = ApiClient.convertToType(data['AreResultsFilterable'], 'Boolean');
      }
      if (data.hasOwnProperty('ParticipantRoles')) {
        obj['ParticipantRoles'] = ApiClient.convertToType(data['ParticipantRoles'], [WorkshopParticipantRole]);
      }
      if (data.hasOwnProperty('Participants')) {
        obj['Participants'] = ApiClient.convertToType(data['Participants'], [WorkshopParticipant]);
      }
      if (data.hasOwnProperty('Phases')) {
        obj['Phases'] = ApiClient.convertToType(data['Phases'], [WorkshopPhaseReport]);
      }
      if (data.hasOwnProperty('VideoCall')) {
        obj['VideoCall'] = WorkshopVideoCall.constructFromObject(data['VideoCall']);
      }
      if (data.hasOwnProperty('Created')) {
        obj['Created'] = ApiClient.convertToType(data['Created'], 'Date');
      }
      if (data.hasOwnProperty('CreatorID')) {
        obj['CreatorID'] = ApiClient.convertToType(data['CreatorID'], 'Integer');
      }
      if (data.hasOwnProperty('OwnerID')) {
        obj['OwnerID'] = ApiClient.convertToType(data['OwnerID'], 'Integer');
      }
      if (data.hasOwnProperty('MilestoneID')) {
        obj['MilestoneID'] = ApiClient.convertToType(data['MilestoneID'], 'Integer');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('IsTemplate')) {
        obj['IsTemplate'] = ApiClient.convertToType(data['IsTemplate'], 'Boolean');
      }
      if (data.hasOwnProperty('IsDemo')) {
        obj['IsDemo'] = ApiClient.convertToType(data['IsDemo'], 'Boolean');
      }
      if (data.hasOwnProperty('DoesFacilitatorParticipate')) {
        obj['DoesFacilitatorParticipate'] = ApiClient.convertToType(data['DoesFacilitatorParticipate'], 'Boolean');
      }
      if (data.hasOwnProperty('ResultSummary')) {
        obj['ResultSummary'] = ApiClient.convertToType(data['ResultSummary'], 'String');
      }
      if (data.hasOwnProperty('MarketID')) {
        obj['MarketID'] = ApiClient.convertToType(data['MarketID'], 'Integer');
      }
      if (data.hasOwnProperty('StrategicGoalID')) {
        obj['StrategicGoalID'] = ApiClient.convertToType(data['StrategicGoalID'], 'Integer');
      }
      if (data.hasOwnProperty('TemplateID')) {
        obj['TemplateID'] = ApiClient.convertToType(data['TemplateID'], 'Integer');
      }
      if (data.hasOwnProperty('PreviewBlobStorageUrl')) {
        obj['PreviewBlobStorageUrl'] = ApiClient.convertToType(data['PreviewBlobStorageUrl'], 'String');
      }
      if (data.hasOwnProperty('DefaultPreviewBlobStorageUrl')) {
        obj['DefaultPreviewBlobStorageUrl'] = ApiClient.convertToType(data['DefaultPreviewBlobStorageUrl'], 'String');
      }
      if (data.hasOwnProperty('IsContinuous')) {
        obj['IsContinuous'] = ApiClient.convertToType(data['IsContinuous'], 'Boolean');
      }
      if (data.hasOwnProperty('CustomBackgroundImageBlobStorageUrl')) {
        obj['CustomBackgroundImageBlobStorageUrl'] = ApiClient.convertToType(data['CustomBackgroundImageBlobStorageUrl'], 'String');
      }
      if (data.hasOwnProperty('PromoteInAgendaHome')) {
        obj['PromoteInAgendaHome'] = ApiClient.convertToType(data['PromoteInAgendaHome'], 'Boolean');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Boolean} AreResultsFilterable
   * @default false
   */
  exports.prototype['AreResultsFilterable'] = false;
  /**
   * @member {Array.<module:model/WorkshopParticipantRole>} ParticipantRoles
   */
  exports.prototype['ParticipantRoles'] = undefined;
  /**
   * @member {Array.<module:model/WorkshopParticipant>} Participants
   */
  exports.prototype['Participants'] = undefined;
  /**
   * @member {Array.<module:model/WorkshopPhaseReport>} Phases
   */
  exports.prototype['Phases'] = undefined;
  /**
   * @member {module:model/WorkshopVideoCall} VideoCall
   */
  exports.prototype['VideoCall'] = undefined;
  /**
   * @member {Date} Created
   */
  exports.prototype['Created'] = undefined;
  /**
   * @member {Integer} CreatorID
   * @default 0
   */
  exports.prototype['CreatorID'] = 0;
  /**
   * @member {Integer} OwnerID
   */
  exports.prototype['OwnerID'] = undefined;
  /**
   * @member {Integer} MilestoneID
   */
  exports.prototype['MilestoneID'] = undefined;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Boolean} IsTemplate
   * @default false
   */
  exports.prototype['IsTemplate'] = false;
  /**
   * @member {Boolean} IsDemo
   * @default false
   */
  exports.prototype['IsDemo'] = false;
  /**
   * @member {Boolean} DoesFacilitatorParticipate
   * @default false
   */
  exports.prototype['DoesFacilitatorParticipate'] = false;
  /**
   * @member {String} ResultSummary
   * @default ''
   */
  exports.prototype['ResultSummary'] = '';
  /**
   * @member {Integer} MarketID
   */
  exports.prototype['MarketID'] = undefined;
  /**
   * @member {Integer} StrategicGoalID
   */
  exports.prototype['StrategicGoalID'] = undefined;
  /**
   * @member {Integer} TemplateID
   */
  exports.prototype['TemplateID'] = undefined;
  /**
   * @member {String} PreviewBlobStorageUrl
   * @default ''
   */
  exports.prototype['PreviewBlobStorageUrl'] = '';
  /**
   * @member {String} DefaultPreviewBlobStorageUrl
   * @default ''
   */
  exports.prototype['DefaultPreviewBlobStorageUrl'] = '';
  /**
   * @member {Boolean} IsContinuous
   * @default false
   */
  exports.prototype['IsContinuous'] = false;
  /**
   * @member {String} CustomBackgroundImageBlobStorageUrl
   * @default ''
   */
  exports.prototype['CustomBackgroundImageBlobStorageUrl'] = '';
  /**
   * @member {Boolean} PromoteInAgendaHome
   * @default false
   */
  exports.prototype['PromoteInAgendaHome'] = false;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


